export const environment = {
  // staging onboarding api url
  // imageBaseUrl: 'https://chp.getmybalance.co.za/',
  // apiBaseUrl: 'https://chp.getmybalance.co.za',

  // imageBaseUrl: 'https://uat-chpapi.paycentral.co.za/',
  // apiBaseUrl: 'https://uat-chpapi.paycentral.co.za',

  imageBaseUrl: 'https://v2-chpapi.paycentral.co.za/',
  apiBaseUrl: 'https://v2-chpapi.paycentral.co.za',

  tokenEndPoint: '/api/token',
  production: false,
  environment: 'Local',
  showEnvironment: true,
};
